export default __webpack_public_path__ + "static/epica-2-3815eb802727227509a721a23c9c61f0.jpg";